(() => {
  const root = document.querySelector('[data-ideenfinder]');
  if (!root) return;
  const form = root.querySelector('[data-filter-form]');
  const list = root.querySelector('[data-ideas-list]');
  const status = root.querySelector('[data-results-status]');
  const empty = root.querySelector('[data-empty]');
  const more = root.querySelector('[data-load-more]');
  const activeFilter = root.querySelector('[data-active-filter]');
  const groupLabels = {
    'kinder-3-6': 'Kinder von 3 bis 6 Jahren',
    'kinder-7-12': 'Kinder von 7 bis 12 Jahren',
    teenager: 'Teenager',
    erwachsene: 'Erwachsene',
    frauen: 'Frauen',
    maenner: 'Männer',
    paare: 'Paare',
    familie: 'Familien',
    'ohne-suessigkeiten': 'ohne Süßigkeiten',
    'unter-5': 'unter 5 Euro',
    nachhaltig: 'nachhaltige Ideen',
    diy: 'selbstgemachte Ideen',
    gutscheine: 'Gutscheine und Aktivitäten',
    'last-minute': 'Last-Minute-Ideen',
    sackchen: 'passend für 15 × 20 cm'
  };
  const pageSize = 24;
  let ideas = [];
  let visibleCount = pageSize;

  const escapeHtml = (value) => String(value).replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character]));
  const matchesAge = (ideaAge, selected) => !selected || ideaAge === selected || ideaAge === '3-99';
  const filtersFromForm = () => Object.fromEntries(new FormData(form).entries());
  const filterIdeas = () => {
    const filters = filtersFromForm();
    return ideas.filter((idea) => (
      (!filters.group || (idea.groups || []).includes(filters.group)) &&
      (!filters.audience || idea.audience.includes(filters.audience)) &&
      matchesAge(idea.age, filters.age) &&
      (!filters.budget || idea.budget === filters.budget) &&
      (!filters.category || idea.category === filters.category) &&
      (!filters.ohne_suessigkeiten || idea.ohne_suessigkeiten) &&
      (!filters.nachhaltig || idea.nachhaltig) &&
      (!filters.selbstgemacht || idea.selbstgemacht) &&
      (!filters.fits_15x20 || idea.fits_15x20)
    ));
  };
  const updateUrl = () => {
    const params = new URLSearchParams();
    Object.entries(filtersFromForm()).forEach(([key, value]) => { if (value) params.set(key, value); });
    const url = new URL(window.location.href);
    url.search = params.toString();
    window.history.replaceState({}, '', url);
  };
  const render = () => {
    const filters = filtersFromForm();
    const results = filterIdeas();
    const shown = results.slice(0, visibleCount);
    list.innerHTML = '';
    const compactList = document.createElement('ul');
    compactList.className = 'adventskalender-idea-list';

    shown.forEach((idea) => {
      const row = document.createElement('li');
      row.className = 'adventskalender-idea-row';

      const title = document.createElement('strong');
      title.textContent = idea.title;

      const meta = document.createElement('span');
      const metaParts = [idea.category, idea.budget];
      if (idea.ohne_suessigkeiten) metaParts.push('ohne Süßigkeiten');
      if (idea.nachhaltig) metaParts.push('nachhaltig');
      if (idea.selbstgemacht) metaParts.push('selbstgemacht');
      if (idea.fits_15x20) metaParts.push('passt in 15 × 20 cm');
      meta.textContent = metaParts.filter(Boolean).join(' · ');

      row.append(title, meta);
      compactList.append(row);
    });

    list.append(compactList);
    status.textContent = `${shown.length} von ${results.length} passenden Ideen angezeigt`;
    activeFilter.hidden = !filters.group;
    activeFilter.textContent = filters.group ? `Auswahl: ${groupLabels[filters.group] || filters.group}` : '';
    empty.hidden = results.length > 0;
    more.hidden = results.length <= shown.length;
    more.textContent = `Weitere Ideen anzeigen (${results.length - shown.length})`;
  };
  const restoreFilters = () => {
    const params = new URLSearchParams(window.location.search);
    [...form.elements].forEach((field) => {
      if (!field.name || !params.has(field.name)) return;
      if (field.type === 'checkbox') field.checked = params.get(field.name) === 'on';
      else field.value = params.get(field.name);
    });
  };
  document.querySelectorAll('[data-ideen-filter]').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      form.reset();
      form.elements.namedItem('group').value = link.dataset.filterGroup || '';
      visibleCount = pageSize;
      updateUrl();
      render();
      root.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });
  });
  form.addEventListener('input', (event) => {
    if (event.target.name !== 'group') form.elements.namedItem('group').value = '';
    visibleCount = pageSize;
    updateUrl();
    render();
  });
  form.addEventListener('reset', () => setTimeout(() => { visibleCount = pageSize; updateUrl(); render(); }));
  more.addEventListener('click', () => { visibleCount += pageSize; render(); });
  fetch(root.dataset.ideasUrl, { credentials: 'same-origin' })
    .then((response) => response.ok ? response.json() : Promise.reject(new Error('Ideen konnten nicht geladen werden.')))
    .then((data) => { ideas = data; restoreFilters(); render(); })
    .catch(() => { status.textContent = 'Die Ideenliste konnte gerade nicht geladen werden. Die Kategorien und FAQ bleiben verfügbar.'; });
})();
